import { Component, OnInit } from '@angular/core';

const NAVLINKS = [
  {title: 'Om procentregning', link:'/procent-rules', content:'Læs lidt om reglerne for at procentregning.'},
  {title: 'Procentdele', link:'/procent-parts', content:'Øv dig på at finde en procent-andel.'},
  {title: 'Renteregning', link:'/procent-interest', content:'Øv dig på at regne med renter.'},
  {title: 'Procentudvikling', link:'/procent-development', content:'Når man regning med udvikling, afgives denne ofte i procent. Lær her hvordan.'}
];

@Component({
  selector: 'app-menu-procent',
  templateUrl: './menu-procent.component.html',
  styleUrls: ['./menu-procent.component.css']
})
export class MenuProcentComponent implements OnInit {

  navLinks = NAVLINKS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/menu-procent/menu-procent.component.ts